(() => {
  const c_OPEN = 'is-mobile-search-open';

  const c_setOpen = (c_top, c_open) => {
    c_top.classList.toggle(c_OPEN, c_open);
    const c_toggle = c_top.querySelector('.c-hd-search-toggle');
    if (c_toggle) c_toggle.setAttribute('aria-expanded', String(c_open));
    if (c_open) {
      // The theme's search closes itself on any outside click, so focus after this click has finished.
      setTimeout(() => c_top.querySelector('.search__input')?.focus(), 50);
    }
  };

  document.addEventListener('click', (c_event) => {
    const c_toggle = c_event.target.closest('.c-hd .c-hd-search-toggle');
    if (c_toggle) {
      const c_top = c_toggle.closest('.header__top');
      c_setOpen(c_top, !c_top.classList.contains(c_OPEN));
      return;
    }
    const c_close = c_event.target.closest('.c-hd .header__search-close');
    if (c_close) c_setOpen(c_close.closest('.header__top'), false);
  });

  document.addEventListener('keydown', (c_event) => {
    if (c_event.key !== 'Escape') return;
    const c_top = document.querySelector(`.c-hd .header__top.${c_OPEN}`);
    if (c_top) c_setOpen(c_top, false);
  });
})();
